import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  @Input() selectedSectionDetail: any;
  faqs;

  constructor() { }

  ngOnInit(): void {
    this.faqs = this.selectedSectionDetail.data;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.faqs = this.selectedSectionDetail.data;
  }

  isArray(data) {
    return Array.isArray(data);
  }

  getListType(depth) {
    let type;

    switch (depth) {
      case 1:
        type = 'I';
        break;
      case 2:
        type = 'i';
        break;
      case 3:
        type = '1';
        break;
      case 4:
        type = 'a';
        break;
      case 5:
        type = 'i';
        break;
      default:
        break;
    }
    return type;
  }
}
